import { FlattenSimpleInterpolation, css } from 'styled-components'
import { colors } from 'const/colors'
import { DisabledProps } from './typings'

export const getTextFieldErrorCss = (
  isError: boolean
): FlattenSimpleInterpolation => {
  return css`
    & .text-field-wrapper {
      box-shadow: 0 0 0 2px ${colors.error};
    }
    & label {
      color: ${colors.error};
    }
    & .credential_error {
      display: ${isError ? 'none' : 'inline-flex'};
    }
  `
}

export const getTextButtonMarginTopCss = (
  marginTop: string
): FlattenSimpleInterpolation => {
  if (marginTop) {
    return css`
      ${marginTop} 0 0;
    `
  }
  return css`8px 0 0`
}

export const checkDisabled = ({
  userID,
  password,
  isUserIdError,
  isLoading
}: DisabledProps): boolean => {
  return !(userID && password && !isUserIdError) || isLoading
}

export const checkUserIdError = (name: string, isUserId: boolean): boolean => {
  return name === 'userID' && isUserId
}

/**
 * This 'error' text is never going to be displayed.
 * It's only being used to enable the CL Textfield component error styles
 */
export const getErrorText = (isLoginFailure: boolean): string =>
  isLoginFailure ? 'error' : ''
